import React from "react";
import { useQuickSightRDS } from "@/hooks/useRDSReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsRDSDashboard from "@/components/organisms/RDSDashboard";

function RDSReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightRDS();

  return (
    <AWSReportsTemplate
      title="AWS RDS Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsRDSDashboard />
    </AWSReportsTemplate>
  );
}

export default RDSReports;
